import Exports from "../../Pages/Mega/Exports";
import {
  ADD_EVENT_FAIL,
  ADD_EVENT_SUCCESS,
  GET_EVENTS_FAIL,
} from "../calendar/actionTypes";
import {
  ADD_IDS_SUCCESS,
  DELETE_IDS_SUCCESS,
  GET_IDS_FAIL,
  GET_IDS_SUCCESS,
  UPDATE_IDS_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  Emails: [],
  error: {},
};

const Emails = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_IDS_SUCCESS:
      return {
        ...state,
        Emails: action.payload.emails,
        exports: action.payload.exports,
      };

    case GET_IDS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_IDS_SUCCESS:
      return {
        ...state,
        Emails: [...state.emails, action.payload],
      };

    case ADD_EVENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_IDS_SUCCESS:
      return {
        ...state,
        Emails: state.Emails.map((id) =>
          id.id === action.payload.id ? { id, ...action.payload } : id
        ),
        isEventUpdated: true,
      };

    // case UPDATE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //     isEventUpdated: false,
    //   };

    case DELETE_IDS_SUCCESS:
      return {
        ...state,
        Emails: state.Emails.filter((id) => id.id !== action.payload),
      };

    // case DELETE_EVENT_FAIL:
    //   return {
    //     ...state,
    //     error: action.payload,
    //   };

    default:
      return state;
  }
};

export default Emails;
